


























// vue
import { defineComponent } from '@vue/composition-api';

// hooks
import { useStore } from '@/store';

export default defineComponent({
    props: {
        label: {
            type: String,
            default: '',
        },
        icon: {
            type: String,
        },
        isSelected: {
            type: Boolean,
            default: false,
        },
    },
    setup() {
        // store
        const { apiUrl } = useStore().state;

        return { apiUrl };
    },
});
